// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Cz-z","tooltipWrapper":"Dz-z","icon":"Ez-z","tooltip":"Fz-z","content":"Gz-z"};